import { Stack, Typography, Card, CardContent, useTheme } from "@mui/material";

interface CardItem {
  image: string;
  title: string;
  description: string;
}

interface VisionSectionProps {
  heading: string;
  items: CardItem[];
}

const VisionCards = ({ heading, items }: VisionSectionProps) => {
  const theme = useTheme();
  return (
    <Stack
      spacing={4}
      sx={{
        py: 6,
        px: { xs: 2, sm: 6 },
        width: { xs: "100%", md: "100%", lg: "90%", xl: "70%" },
        alignSelf: "center",
      }}
    >
      <Typography
        variant="h3"
        sx={{
          textAlign: "center",
          fontWeight: "700",
          fontFamily: "Work Sans",
          mb: 4,
        }}
      >
        {heading}
      </Typography>
      <Stack direction="row" flexWrap="wrap" justifyContent="center" gap={4}>
        {items.map((item, index) => (
          <Card
            key={index}
            sx={{
              width: { xs: "100%", sm: "45%", md: "30%" },
              borderRadius: 2,
              boxShadow: 3,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <Stack
              sx={{
                width: "100%",
                height: { xs: 180, sm: 200, md: 220, lg: "auto" },
                overflow: "hidden",
              }}
            >
              <img
                src={item.image}
                alt={item.title}
                loading="lazy"
                style={{
                  width: "100%",
                  height: "100%",
                  aspectRatio: "1.8/1",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </Stack>
            <CardContent sx={{ textAlign: "center", flexGrow: 1 }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "600",
                  color: theme.palette.primary.main,
                  mb: 1,
                }}
              >
                {item.title}
              </Typography>
              <Typography
                sx={{
                  color: theme.palette.grey[600],
                  fontFamily: "Work Sans",
                  fontWeight: "400",
                  fontSize: { xs: 14, sm: 15 },
                }}
              >
                {item.description}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Stack>
  );
};

export { VisionCards };
